import React from 'react';

import {HStack, Text, VStack} from "@chakra-ui/react";

import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";

export const ReferenceListBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        maxH="6rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    {stringUtil.getRandomString(10, 25)}
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const DivisionBody = ({element, ...props}) => {
    return (
        <HStack gap="1vw" minH="3.5rem" maxH="6rem" color="secondary.500" overflow="hidden" {...props}>
            <VStack align="flex-start" justify="center" flex={1} overflow="hidden">
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    {element?.label}
                </Text>
            </VStack>
        </HStack>
    );
};

export const ClubBody = ({element, ...props}) => {
    return (
        <HStack gap="1vw" minH="3.5rem" maxH="6rem" color="secondary.500" overflow="hidden" {...props}>
            <VStack align="flex-start" justify="center" gap={0} flex={1} overflow="hidden">
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    {element?.label}
                </Text>
                <Text fontSize="sm" opacity={0.7} isTruncated>
                    {element?.labelDivision ?? '—'}
                </Text>
            </VStack>
        </HStack>
    );
};
